// extracted by mini-css-extract-plugin
module.exports = {"Btn":"YellowButton_Btn__1w0Y-","BtnDisabled":"YellowButton_BtnDisabled__PShpD"};